import { defineStyle } from '@chakra-ui/react';

export const cockpitHeaderVariant = defineStyle({
  rounded: 'none',
  paddingX: '1.5 !important',
  borderRadius: 0,
  border: 'none',
  gap: 1,
  color: 'neutral.300',
  _icon: {
    color: 'neutral.300',
  },
  _hover: {
    backgroundColor: 'neutral.700',
    color: 'neutral.white',
    _icon: {
      color: 'skyBlue !important',
    },
  },
  _disabled: {
    cursor: 'default',
    color: 'neutral.600',
    backgroundColor: 'neutral.800',
    opacity: 1,
  },
});
